














import { defineComponent } from '@nuxtjs/composition-api';
import { BaseImage } from '@shared/ui';

export default defineComponent({
  name: 'StoryblokImage',
  components: {
    BaseImage,
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
});
